import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { DuplicateParametersResponse } from './types';

export const [
  duplicateCoverageParametersAtom,
  duplicateCoverageParametersLoadableAtom,
] = atomWithLoadable(async () => {
  const response = await request.get<DuplicateParametersResponse>(
    '/admin/duplicate_coverage_parameters'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const [
  duplicateAnalysisParametersAtom,
  duplicateAnalysisParametersLoadableAtom,
] = atomWithLoadable(async () => {
  const response = await request.get<DuplicateParametersResponse>(
    '/admin/duplicate_analysis_parameters'
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});
